/**
 * Shared Pipes Index
 * Central export for all shared pipes
 */

export * from './currency.pipe';
export * from './safe-html.pipe';
